import {TreeNode} from "@/types";
import {get_color} from "@/pages/mindmap/CarNodes/BasicCardNode.tsx";
import {formatCompactNumber, formatPercentage} from "@/utils/format.ts";


export const CategoryRegionNode  = ({node}: {node:TreeNode}) => {

    const datas = node.metrics_map || {}

    const get_child_gap = (rank:string) => {
        const child = node.children?.find(c => c.name === rank)
        const datas = child?.metrics_map || {}

        return <div>
            <span>{rank}: &nbsp;</span>
            {(datas["ims_amt_mtd_gap"]?.value ?? 0) < 0 ?
                <span style={get_color("ims_amt_mtd_gap", datas)}>
                    {formatCompactNumber((datas["ims_amt_mtd_gap"]?.value ?? 0))}
            </span>:
                <>--</>
            }
        </div>
    }


    return <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '2px 12px',
        marginBottom: '2px',
        color: 'rgb(71, 85, 105)'
    }}>
        <div style={{fontWeight: 700, color: 'rgb(30, 41, 59)'}}>IMS Contribution (MTD)</div>
        <div style={{fontWeight: 700, color: 'rgb(30, 41, 59)'}}>IMS Gap (MTD)</div>

        <div>
            <span>Core: </span>
            <span style={get_color("core_amt_pct", datas)}>
                {formatPercentage(datas["core_amt_pct"]?.value)}
            </span>
        </div>
        {get_child_gap("Core")}

        <div>
            <span>Broad: </span>
            <span style={get_color("bm_amt_pct", datas)}>
                {formatPercentage(datas["bm_amt_pct"]?.value)}
            </span>
        </div>
        {get_child_gap("Broad")}

    </div>
}